export const USER_ROLES = ['super_admin', 'admin', 'store_manager', 'customer'] as const;
export type UserRole = (typeof USER_ROLES)[number];

export const ORDER_STATUSES = [
  'pending_payment',
  'payment_processing',
  'paid',
  'preparing',
  'shipped',
  'delivered',
  'cancelled',
  'refunded',
] as const;
export type OrderStatus = (typeof ORDER_STATUSES)[number];

export const PAYMENT_METHODS = ['mbway', 'multibanco', 'credit_card', 'bank_transfer'] as const;
export type PaymentMethod = (typeof PAYMENT_METHODS)[number];

export const PAYMENT_STATUSES = ['pending', 'processing', 'paid', 'failed', 'refunded'] as const;
export type PaymentStatus = (typeof PAYMENT_STATUSES)[number];

export const DISCOUNT_TYPES = ['percentage', 'fixed_amount', 'free_shipping'] as const;
export type DiscountType = (typeof DISCOUNT_TYPES)[number];

export const VAT_RATE_PT = 0.23;
export const CURRENCY = 'EUR' as const;
export const LOCALE = 'pt-PT' as const;

// MB WAY: SIBS gives the customer a fixed window to approve the push in
// the MB WAY app (the merchant cannot extend it via EasyPay). 4 minutes is
// the SIBS default; we use this only for client-side UX (countdown + poll
// cutoff). Authoritative status still comes from EasyPay webhook + DB.
export const MBWAY_ACCEPT_WINDOW_MS = 4 * 60 * 1000;

export const ROLE_HIERARCHY: Record<UserRole, UserRole[]> = {
  super_admin: ['super_admin', 'admin', 'store_manager', 'customer'],
  admin: ['admin', 'store_manager', 'customer'],
  store_manager: ['store_manager', 'customer'],
  customer: ['customer'],
};

export function roleHasAccess(userRole: UserRole, requiredRole: UserRole): boolean {
  return ROLE_HIERARCHY[userRole]?.includes(requiredRole) ?? false;
}
